import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { HttpClient, HttpEvent, HttpEventType, HttpHeaders, HttpRequest } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject, Observable, Subject, throwError, of } from 'rxjs';
import { catchError, map, takeUntil, delay, switchMap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Dictionary } from './interface';
import { ContentType } from './enums';
import { StoreService } from './store.service';
import { Utils } from '../helpers/utils';
import { NgxPermissionsService } from '../modules/ngx-permissions';
import { urlSafeBase64Encoding } from '../helpers';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from './loader.service';
import { DemoDataService } from './demo-data.service';

@Injectable()
export class RequestService {
  public isNetworkConnected: boolean = true;
  private authURL = environment.serverUrl;
  private scheduleURL = environment.scheduleUrl;
  public orgType = environment.orgType;
  private loading: boolean = false;
  private token: any = '';
  private userType: string = 'default';
  public currentPageTitle: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);
  public orgId: string = environment.orgId;
  public appId: string = environment.appId;
  public locId: string = environment.locId;
  public tabId = "";
  public lang = 'en';
  public environmentserverHostUrl = environment.serverHostUrl;
  public fileUploadProgress: Subject<number> = new Subject<number>();
  public serverHostUrl = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');
  // public formLibModules = ['assessment', 'rules', 'diagnostic'];
  public appStatusSubject: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);
  public authenticatedUser: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public pageOrganization: BehaviorSubject<any> = new BehaviorSubject<any>(undefined);
  public cachedObj = {};
  public currentUserSubject: BehaviorSubject<any | undefined> = new BehaviorSubject<any | undefined>(undefined);
  // public abortController: AbortController | null = null;
  public $destroy = new Subject<void>();
  public _currentUser: any | undefined = undefined;
  reloadTimeline = new BehaviorSubject(null);
  set currentUser(currentUser: any | undefined) {
    if (currentUser) {
      // currentUser.token = 'n7m0c2b9z6C9u3w9eliufhfnjkdnbcaakjdhgasdhflhaigkladsglghakoiruegkajsnbnvvjvbv';
      this._currentUser = currentUser;
      let userObject: any = currentUser;
      this.userType = currentUser.dup__of_type || 'default';
      this.store.init('default_' + userObject._id);
      this.setToken(userObject.token);
      localStorage.setItem('currentUser', JSON.stringify(userObject));
      this.currentUserSubject.next(userObject);
      // this.store.set('te', 'temp');
      this.permissionsService.flushPermissions();
      this.permissionsService.addPermission(this.userType);
      // for (let res of userObject.resources) {
      //   this.permissionsService.addPermission(res._id);
      // }
    } else {
      this._currentUser = undefined;
      // this.orgId = undefined;
      this.currentUserSubject.next(undefined);
      localStorage.removeItem('currentUser');
      this.token = '';
      this.userType = 'default';
      this.store.init('default');
      this.permissionsService.flushPermissions();
      // this.permissionsService.flushPermissions();
    }
  }
  get currentUser(): any | undefined {
    return this._currentUser;
  }

  public updatePermissions(userType) {
    this.permissionsService.flushPermissions();
    this.permissionsService.addPermission(userType);
  }
  public updateCurrentUser(newData: any) {
    let objectUser = Object.assign(this._currentUser, newData);
    this.currentUser = objectUser;
  }
  public updateUserData(key, value) {
    let userObject: any = this.currentUserSubject.getValue();
    // let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    userObject[key] = value;
    localStorage.setItem('currentUser', JSON.stringify(userObject));
    this.currentUserSubject.next(userObject);
  }
  public updateSetOfUserData(dateList = []) {
    let userObject: any = this.currentUserSubject.getValue();
    for (let itm of dateList) {
      userObject[itm.key] = itm.value;
    }
    localStorage.setItem('currentUser', JSON.stringify(userObject));
    this.currentUserSubject.next(userObject);
  }
  public updateCommonUserData(userDate) {
    let userObject: any = this.currentUserSubject.getValue();
    let defaultFields: string[] = ['firstName', 'lastName', 'phone', 'region', 'prefecture', 'pictureLink'];
    for (let itm of defaultFields) {
      userObject[itm] = userDate[itm];
    }
    localStorage.setItem('currentUser', JSON.stringify(userObject));
    this.currentUserSubject.next(userObject);
  }
  constructor(private utils: Utils, public store: StoreService, private router: Router, private http: HttpClient, private route: ActivatedRoute,
    private permissionsService: NgxPermissionsService, private dialog: MatDialog, private translate: TranslateService, private loader: LoaderService, private location: Location, private demoDataService: DemoDataService) {
    this.store.init('Anonomous');
    localStorage.setItem('o', JSON.stringify(this.orgId));
    localStorage.setItem('a', JSON.stringify(this.appId));
    localStorage.setItem('l', JSON.stringify(this.locId));
    if (localStorage.getItem('languageSelected')) {
      this.lang = localStorage.getItem('languageSelected');
    } else {
      localStorage.setItem('languageSelected', this.lang);
    }
  }
  public loggedIn() {
    if (this.currentUser) {
      return true;
    } else {
      return false;
    }
  }
  public getUserType() {
    return this.userType;
  }
  public getUserId() {
    if (this.currentUser && this.currentUser.hasOwnProperty('_id')) {
      return this.currentUser['_id'];
    } else {
      return '';
    }
  }
  public setToken(token: any) {
    this.token = token;
  }
  public getToken() {
    return this.token;
  }
  public redirectTo(uri: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([uri]));
  }
  public addLanguageToURL(url: string, lang?: string): string {
    // if (url) {
    //   let langEnd = lang;
    //   if (langEnd === undefined) {
    //     langEnd = 'en';
    //   }
    //   if (~url.indexOf('?')) {
    //     url += '&locale=' + langEnd;
    //   } else {
    //     url += '?locale=' + langEnd;
    //   }
    //   return url;
    // } else {
    //   return '';
    // }
    return url;
  }
  public addLangToURL(url: string, lang?: string): string {
    if (url) {
      let langEnd = lang;
      if (langEnd === undefined) {
        langEnd = 'en';
      }
      if (~url.indexOf('?')) {
        url += '&language=' + langEnd;
      } else {
        url += '?language=' + langEnd;
      }
      return url;
    } else {
      return '';
    }
    // return url;
  }

  public verifyUserEmail(token: string, organizationId: string, appId: string, locationId: string, callback: (dataResponse: any | undefined,
    requestError: any | undefined, returnIt: boolean) => void, lang?: string) {

    this.token = token;
    let urlStr = this.authURL + 'user/valid/' + organizationId + '/' + appId + '/' + locationId;
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonGetRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        //console.log(error);
        if (jsonObj && jsonObj.hasOwnProperty('return')) {
          callback(undefined, error, jsonObj.return);
        } else {
          callback(undefined, error, false);
        }
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          let userObject = jsonObj.results;
          if (jsonObj.hasOwnProperty('token')) {
            if (jsonObj.token) {
              // this.setToken(jsonObj.token);
              //this.token = jsonObj.token;
              //this.store.set('token', jsonObj.token)
            }
            //userObject['token'] = jsonObj.token;
          }
          callback(userObject, undefined, false);
        } else {
          if (jsonObj.hasOwnProperty('return')) {
            callback(undefined, jsonObj, jsonObj.return);
          } else {
            callback(undefined, jsonObj, false);
          }
        }
      } else {
        callback(undefined, 'Data error from server ', false);
      }
    });
  }


  public requestLoginTokenCheck(token: string, callback: (dataResponse: any | undefined,
    requestError: any | undefined, returnIt: boolean) => void, refreshToken: string = '', lang?: string) {
    this.token = token;
    let urlStr = this.authURL + 'user/login/bytoken';
    let data = {
      refreshtoken: refreshToken
    }
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        //console.log(error);
        if (jsonObj && jsonObj.hasOwnProperty('return')) {
          callback(undefined, error, jsonObj.return);
        } else {
          callback(undefined, error, false);
        }
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          let userObject = jsonObj.results;
          if (jsonObj.hasOwnProperty('token')) {
            if (jsonObj.token) {
              this.setToken(jsonObj.token);
              this.token = jsonObj.token;
              this.store.set('token', jsonObj.token)
            }
            userObject['token'] = jsonObj.token;
          }
          callback(userObject, undefined, false);
        } else {
          if (jsonObj.hasOwnProperty('return')) {
            callback(undefined, jsonObj, jsonObj.return);
          } else {
            callback(undefined, jsonObj, false);
          }
        }
      } else {
        callback(undefined, 'Data error from server ', false);
      }
    }, 'POST', data);
  }

  public getListContains(lst: any[], idKey: string = '_id'): any[] {
    let dataList = [];
    for (let itm of lst) {
      if (itm.hasOwnProperty(idKey)) {
        dataList.push(itm[idKey]);
      }
    }
    return dataList;
  }
  public validateMe() {
    console.log('validateMe');
    if (localStorage.getItem('currentUser') && localStorage.getItem('o')) {
      let currentStorageUser = JSON.parse(localStorage.getItem('currentUser'));
      let orgId = JSON.parse(localStorage.getItem('o'));
      if (currentStorageUser._id !== this.currentUser._id) {
        return false;
      }
      if (orgId !== this.orgId) {
        return false;
      }
    } else {
      return false;
    }
    return true;
  }
  public getBrand() {
    let serverHostUrl = this.environmentserverHostUrl.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "").split('/')[0];
    let currentHostname = (window.location.hostname).replace(/^(?:https?:\/\/)?(?:www\.)?/i, "").split('/')[0];
    if (currentHostname !== 'localhost' && serverHostUrl !== currentHostname) {
      let remainingLink = currentHostname.replace(serverHostUrl, "");
      remainingLink = remainingLink.replace('.', "");
      return remainingLink;
    }
    return undefined;
  }
  public getDataFromList(lst: any[], idKey: string = '_id'): string[] {
    let dataList = [];
    for (let itm of lst) {
      if (itm.hasOwnProperty(idKey)) {
        dataList.push(itm[idKey]);
      }
    }
    return dataList;
  }
  public getDataFromListContains(lst: any[], val: string[], idKey: string = '_id'): any[] {
    let dataList = [];
    for (let itm of lst) {
      if (itm.hasOwnProperty(idKey) && val.includes(itm[idKey])) {
        dataList.push(itm);
      }
    }
    return dataList;
  }
  public getItemFromListContains(lst: any[], val: string, idKey: string = '_id'): any {
    if (lst) {
      for (let itm of lst) {
        if (itm.hasOwnProperty(idKey) && itm[idKey] === val) {
          return itm;
        }
      }
    }
    return undefined;
  }
  public getItemFromListContainsDisplay(lst: any[], val: string, idKey: string = '_id', displayName: string = 'name'): any {
    if (lst) {
      for (let itm of lst) {
        if (itm.hasOwnProperty(idKey) && itm[idKey] === val) {
          return itm[displayName];
        }
      }
    }
    return '';
  }
  public checkListContains(lst: any[], val: string, idKey: string = '_id'): boolean {
    for (let itm of lst) {
      if (itm.hasOwnProperty(idKey) && itm[idKey] === val) {
        return true;
      }
    }
    return false;
  }
  public logout(showDialog: boolean = false, redirect: boolean = true) {
    // console.log('logout');
    localStorage.removeItem('currentUser');
    localStorage.removeItem('last-request-checked');
    localStorage.removeItem('o');
    localStorage.removeItem('a');
    localStorage.removeItem('l');
    // localStorage.removeItem('org'); // uncomment this if we let user select org
    // localStorage.removeItem('dnd');
    localStorage.removeItem('unreadChats');
    localStorage.removeItem('subscribed-topics');
    // sessionStorage.removeItem('DND');
    this.appStatusSubject.next(undefined);
    this.authenticatedUser.next(false);
    this.currentUser = undefined;

    if (navigator.serviceWorker) {
      navigator.serviceWorker.getRegistrations().then(function (registrations) {
        for (let registration of registrations) {
          registration.unregister()
        }
      })
    }
    this.loader.display(false);
    // this.firebaseAuthService.signOut().finally(() => {
    // if (redirect) {
    //   if (showDialog) {
    //     this.location.go('/loginWithDialog');
    //     window.location.reload();
    //     this.router.navigateByUrl('loginWithDialog');
    //     // this.router.navigateByUrl('/login').then(() => {
    //     //   window.location.reload();
    //     // });
    //   } else {
    //     this.location.go('/auth/login');
    //     // window.location.reload();
    //     this.router.navigateByUrl('auth/login');
    //     // this.router.navigateByUrl('/login').then(() => {
    //     //   window.location.reload();
    //     // });
    //   }
    // }

    this.router.navigateByUrl('/login').then(() => {
      if (redirect) {
        window.location.reload();
      }
    });

    // }).catch((error) => {
    //   console.log('error', error);
    //   this.router.navigateByUrl('auth/login');
    // });
  }
  public logOutApi(firebaseToken: string = '') {
    if (!this.loading && this.token !== '') {
      this.loading = true;
      this.postRequest('user', 'auth/logout', {
        userId: this.currentUser._id,
        deviceToken: firebaseToken,
      }, (jsonObj, error) => {
        if (error !== undefined) {
          //     // do nothing
          this.logout();
        }
        if (jsonObj) {
          this.logout();
        }
        this.loading = false;
      });
    }
  }
  public getMe(callback: (dataResponse: any | undefined,
    requestError: any | undefined) => void, lang?: string) {
    let urlStr = this.authURL + 'user/me';

    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonGetRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          let userObject = jsonObj.results;
          callback(userObject, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, 'Data error from server ');
      }
    });
  }
  public requestAuthLogin(username: string, password: string, callback: (dataResponse: any | undefined,
    requestError: any | undefined, returnIt: boolean) => void, lang?: string) {
    let encodedPassword = urlSafeBase64Encoding(password); // make it from backend

    let data = {};
    this.token = '';
    // data["email"] = encodeURIComponent(username);
    data["email"] = username;
    data["password"] = encodedPassword;
    let urlStr = this.authURL + 'user/login';
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        if (jsonObj && jsonObj.hasOwnProperty('return')) {
          callback(undefined, error, jsonObj.return);
        } else {
          callback(undefined, error, false);
        }
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          let userObject = {};
          //this.updatePermissions('general');
          if (jsonObj.hasOwnProperty('token')) {
            userObject['token'] = jsonObj.token;
          }
          if (jsonObj.hasOwnProperty('ftoken')) {
            userObject['ftoken'] = jsonObj.ftoken;
          }
          if (jsonObj.hasOwnProperty('refreshToken')) {
            userObject['refreshToken'] = jsonObj.refreshToken;
          }
          if (jsonObj.hasOwnProperty('handshakeToken')) {
            userObject['handshakeToken'] = jsonObj.handshakeToken;
          }
          callback(userObject, undefined, false);
        } else {
          if (jsonObj.hasOwnProperty('return')) {
            callback(undefined, jsonObj.message, jsonObj.return);
          } else {
            callback(undefined, jsonObj.message, false);
          }
        }
      } else {
        callback(undefined, 'Data error from server ', false);
      }
    }, 'POST', data);
  } public requestLogin(username: string, password: string, callback: (dataResponse: any | undefined,
    requestError: any | undefined, returnIt: boolean) => void, lang?: string) {
    let encodedPassword = urlSafeBase64Encoding(password); // make it from backend

    let data = {};
    this.token = '';
    // data["email"] = encodeURIComponent(username);
    data["email"] = username;
    data["password"] = encodedPassword;
    let urlStr = this.authURL + 'user/auth/login';
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        if (jsonObj && jsonObj.hasOwnProperty('return')) {
          callback(undefined, error, jsonObj.return);
        } else {
          callback(undefined, error, false);
        }
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          let userObject = jsonObj.results;
          //this.updatePermissions('general');

          if (jsonObj.hasOwnProperty('token')) {
            this.setToken(jsonObj.token);
            userObject['token'] = jsonObj.token;
          }
          if (jsonObj.hasOwnProperty('ftoken')) {
            userObject['ftoken'] = jsonObj.ftoken;
          }
          callback(userObject, undefined, false);
        } else {
          if (jsonObj.hasOwnProperty('return')) {
            callback(undefined, jsonObj.message, jsonObj.return);
          } else {
            callback(undefined, jsonObj.message, false);
          }
        }
      } else {
        callback(undefined, 'Data error from server ', false);
      }
    }, 'POST', data);
  }
  public forgotPassword(username: string, callback: (dataResponse: any | undefined,
    requestError: any | undefined, returnIt: boolean) => void, lang?: string) {
    let urlStr = this.authURL + 'user/forgotpassword';
    let postData = {
      email: username
    }
    // urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        if (error.hasOwnProperty('return')) {
          callback(undefined, error, jsonObj.return);
        } else {
          callback(undefined, error, false);
        }
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined, false);
        } else {
          if (jsonObj.hasOwnProperty('return')) {
            callback(undefined, jsonObj.message, jsonObj.return);
          } else {
            callback(undefined, jsonObj.message, false);
          }
        }
      } else {
        callback(undefined, 'Data error from server ', false);
      }
    }, 'POST', postData);
  }
  public validateUser(callback: (dataResponse: any | undefined,
    requestError: any | undefined) => void, lang?: string) {
    let urlStr = this.authURL + 'user/valid';
    callback(true, undefined);
    // this.jsonGetRequest(urlStr, (jsonObj, error) => {
    //     if (error !== undefined) {
    //         callback(undefined, error);
    //         return;
    //     }
    //     if (jsonObj) {
    //       if (jsonObj.status) {
    //         callback(true, undefined);
    //       }else {
    //         callback(undefined, jsonObj.message);
    //       }
    //     } else {
    //       callback(undefined, 'Data error from server ');
    //     }
    // });
  }
  private toBase64(stringToSign: string) {
    let base64 = btoa(stringToSign);
    return base64;
  }
  public getMetaData(type: string, fields: any[], callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string) {
    let urlStr = this.authURL;
    urlStr = urlStr + type + '/metadata';
    if (fields) {
      urlStr = urlStr + '?fields=' + fields;
    }

    // urlStr = this.addLanguageToURL(urlStr, lang);
    urlStr = this.addLangToURL(urlStr, this.lang);
    this.jsonGetRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {

        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    });
  }
  public saveData(type: string, data: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string) {
    if (data.hasOwnProperty('_id') && data._id) {
      let urlStr = this.authURL;
      urlStr = urlStr + type + '/' + data._id;
      this.jsonRequest(urlStr, (jsonObj, error) => {
        if (error !== undefined) {
          callback(undefined, 'Server Error!');
          return;
        }
        if (jsonObj) {
          if (jsonObj.status) {
            callback(jsonObj, undefined);
          } else {
            if (jsonObj.hasOwnProperty('type')) {
              this.appStatusSubject.next(jsonObj.type);
            }
            callback(undefined, jsonObj.message);
          }
        } else {
          callback(undefined, error);
        }
      }, 'POST', data);
    } else {
      let urlStr = this.authURL;
      urlStr = urlStr + type;

      // urlStr = this.addLanguageToURL(urlStr, lang);
      this.jsonRequest(urlStr, (jsonObj, error) => {
        if (error !== undefined) {
          callback(undefined, 'Server Error!');
          return;
        }
        if (jsonObj) {
          if (jsonObj.status) {
            callback(jsonObj, undefined);
          } else {
            if (jsonObj.hasOwnProperty('type')) {
              this.appStatusSubject.next(jsonObj.type);
            }
            callback(undefined, jsonObj.message);
          }
        } else {
          callback(undefined, error);
        }
      }, 'POST', data);
    }
  }
  public saveDataNoPerfix(type: string, data: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string) {
    if (data.hasOwnProperty('_id') && data._id) {
      let urlStr = this.authURL + type + '/' + data._id;
      // console.log(urlStr);
      this.jsonRequest(urlStr, (jsonObj, error) => {
        if (error !== undefined) {
          callback(undefined, 'Server Error!');
          return;
        }
        if (jsonObj) {
          if (jsonObj.status) {
            callback(jsonObj, undefined);
          } else {
            if (jsonObj.hasOwnProperty('type')) {
              this.appStatusSubject.next(jsonObj.type);
            }
            callback(undefined, jsonObj.message);
          }
        } else {
          callback(undefined, error);
        }
      }, 'POST', data);
    } else {
      let urlStr = this.authURL + type;
      // urlStr = this.addLanguageToURL(urlStr, lang);
      this.jsonRequest(urlStr, (jsonObj, error) => {
        if (error !== undefined) {
          callback(undefined, 'Server Error!');
          return;
        }
        if (jsonObj) {
          if (jsonObj.status) {
            callback(jsonObj, undefined);
          } else {
            if (jsonObj.hasOwnProperty('type')) {
              this.appStatusSubject.next(jsonObj.type);
            }
            callback(undefined, jsonObj.message);
          }
        } else {
          callback(undefined, error);
        }
      }, 'POST', data);
    }
  }
  public signUp(data: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, useOrg: boolean = false, lang?: string) {
    let urlStr = this.authURL + 'resource/signup';
    if (useOrg) {
      urlStr = urlStr + '/' + this.orgId
    }
    // urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, 'Server Error!');
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    }, 'POST', data);
  }
  public cropImageByOrg(data: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string) {
    let urlStr = this.authURL + 'img/crop/' + this.orgId;
    // urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, 'Server Error!');
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    }, 'POST', data);
  }
  public cropImageByOrgByUsr(userId: string, data: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string) {
    let urlStr = this.authURL + 'img/crop/' + this.orgId + '/' + userId;
    // urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, 'Server Error!');
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    }, 'POST', data);
  }
  public getSingleData(type: string, id: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string) {
    let urlStr = "";
    urlStr = this.authURL + type + '/' + id;

    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonGetRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    });
  }
  public getSingleCachData(type: string, id: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, cached: boolean = false, lang?: string) {
    if (cached) {
      if (this.cachedObj.hasOwnProperty(type + '/' + id)) {
        callback(this.cachedObj[type + '/' + id], undefined);
        return;
      }
    }
    let urlStr = this.authURL + type + '/' + id;
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonGetRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          if (cached) {
            this.cachedObj[type] = jsonObj.results;
          }
          callback(jsonObj.results, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    });
  }
  public getMySingleData(type: string, id: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string) {
    let urlStr = this.authURL + type + '/' + id;
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonGetRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    });
  }
  public deleteSingleData(type: string, id: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string, checkusability: boolean = false) {
    let urlStr = this.authURL + type + '/' + id + '/delete';
    let objData = undefined;
    if (checkusability) {
      objData = {
        check: checkusability
      };
    }
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    }, 'POST', objData);
  }
  public deleteSingleImageData(type: string, id: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string, checkusability: boolean = false) {
    let urlStr = this.authURL + type + '/' + id + '/deletepicture';
    let objData = undefined;
    if (checkusability) {
      objData = {
        check: checkusability
      };
    }
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    }, 'POST', objData);
  }
  public deleteSingleDataByOrg(type: string, id: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string, checkusability: boolean = false) {
    let urlStr = this.authURL + type + '/' + id + '/' + this.orgId + '/delete';
    urlStr = this.addLanguageToURL(urlStr, lang);
    let objData = undefined;
    if (checkusability) {
      objData = {
        check: checkusability
      };
    }
    this.jsonRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    }, 'POST', objData);
  }
  public deleteSingleDataByApi(type: string, id: any, targetApi: string, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string) {
    let urlStr = this.authURL + type + '/' + id + '/' + targetApi;
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    }, 'POST');
  }
  public deleteProfileImage(type: string, id: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string) {
    let urlStr = this.authURL + type + '/' + id + '/deleteprofile';
    urlStr = this.addLanguageToURL(urlStr, lang);
    let objData = {
      // folder: "string",
      url: id
    };
    this.jsonRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    }, 'POST', objData);
  }
  public deleteImageData(type: string, id: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string) {
    let urlStr = this.authURL + type + '/' + id + '/removeimage';
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    }, 'POST', {});
  }
  public deleteImageDataByOrg(type: string, id: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string) {
    let urlStr = this.authURL + type + '/delete/' + this.orgId;
    urlStr = this.addLanguageToURL(urlStr, lang);
    let objData = {
      // folder: "string",
      url: id
    };
    this.jsonRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    }, 'POST', objData);
  }
  public deleteImageDataByOrgByUsr(userId: string, type: string, id: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string) {
    let urlStr = this.authURL + type + '/delete/' + this.orgId + '/' + userId;
    urlStr = this.addLanguageToURL(urlStr, lang);
    let objData = {
      // folder: "string",
      url: id
    };
    this.jsonRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    }, 'POST', objData);
  }
  public deleteBackgroundImageData(type: string, id: string, imageUrl: string, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string) {
    let urlStr = this.authURL + 'img/delete/' + id + '/tilebackground';
    let data = {
      type: type,
      imageUrl: imageUrl
    };
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    }, 'POST', data);
  }
  public getDataListByGet(type: string, conf: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string) {
    let urlStr = this.authURL + type + '/list';
    // let urlStr = this.authURL + 'app/' + type;
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonGetRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    });
  }
  public getDataListByOrgByGet(type: string, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string) {
    let urlStr = this.authURL + type + '/list/' + this.orgId;
    // let urlStr = this.authURL + 'app/' + type;
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonGetRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    });
  }
  public getDataListByOrgByGetByUsr(userId: string, type: string, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string) {
    let urlStr = this.authURL + type + '/list/' + this.orgId + '/' + userId;
    // let urlStr = this.authURL + 'app/' + type;
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonGetRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    });
  }
  public getDataListBySelection(type: string, sessionId: string, conf: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, source: string = '', sourceTarget: string = '', lang?: string) {
    let cleanConf = this.buildSearchRequestSToAPI(conf, '');
    let urlStr = this.authURL + source + type + '/' + sessionId + '/tilesearch';
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    }, 'POST', cleanConf);
  }
  public getDataList(type: string, conf: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, source: string = '', sourceTarget: string = '', lang?: string) {
    let cleanConf = this.buildSearchRequestSToAPI(conf, '');

    let urlStr = this.authURL;

    urlStr = urlStr + source + type + '/search' + sourceTarget;

    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    }, 'POST', cleanConf);
  }
  public getDataListByListByOrg(type: string, conf: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, source: string = '', sourceTarget: string = '', lang?: string) {
    let cleanConf = this.buildSearchRequestSToAPI(conf, '');
    let urlStr = this.authURL + source + type + '/list/' + this.orgId;
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    }, 'POST', cleanConf);
  }
  public getDataListByListByOrgByUsr(userId: string, type: string, conf: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, source: string = '', sourceTarget: string = '', lang?: string) {
    let cleanConf = this.buildSearchRequestSToAPI(conf, '');
    let urlStr = this.authURL + source + type + '/list/' + this.orgId + '/' + userId;
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    }, 'POST', cleanConf);
  }
  public getDataListByList(type: string, conf: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, source: string = '', sourceTarget: string = '', lang?: string) {
    let cleanConf = this.buildSearchRequestSToAPI(conf, '');
    let urlStr = this.authURL + source + type + '/list';
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    }, 'POST', cleanConf);
  }
  public getDataListSummary(type: string, conf: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, cached: boolean = false, lang?: string) {
    let cleanConf = this.buildSearchRequestSToAPI(conf, '');
    let urlStr = this.authURL;
    urlStr = urlStr + type + '/search/summary';
    urlStr = this.addLanguageToURL(urlStr, lang);
    return this.jsonRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          if (cached) {
            this.cachedObj[type] = jsonObj;
          }
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    }, 'POST', cleanConf);
  }
  public getDataLByOrg(type: string, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, cached: boolean = false, lang?: string) {
    if (cached) {
      if (this.cachedObj.hasOwnProperty(type + '/' + this.orgId)) {
        callback(this.cachedObj[type + '/' + this.orgId], undefined);
        return;
      }
    }
    // let urlStr = this.authURL  + type;
    let urlStr = this.authURL + type + '/list/' + this.orgId;
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonGetRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          if (cached) {
            this.cachedObj[type + '/' + this.orgId] = jsonObj;
          }
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    });
  }
  public getDataLByOrgType(datatype: string, type: string, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, cached: boolean = false, lang?: string) {
    if (cached) {
      if (this.cachedObj.hasOwnProperty(datatype + '/' + this.orgId + '/' + type)) {
        callback(this.cachedObj[datatype + '/' + this.orgId + '/' + type], undefined);
        return;
      }
    }
    let urlStr = this.authURL + datatype + '/list/' + this.orgId + '/' + type;
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonGetRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          if (cached) {
            this.cachedObj[datatype + '/' + this.orgId + '/' + type] = jsonObj;
          }
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    });
  }
  public getDataL(type: string, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, cached: boolean = false, extraId: string = '', lang?: string, subDataType?: string) {

    if (cached) {
      if (this.cachedObj.hasOwnProperty(type + '/' + extraId)) {
        callback(this.cachedObj[type + '/' + extraId], undefined);
        return;
      }
    }

    // let urlStr = this.authURL  + type;
    // let urlStr = this.authURL + type + '/list';
    let urlStr = this.authURL + type;
    if (subDataType === undefined) {

      urlStr = urlStr + '/list';
    }
    else {

      urlStr = urlStr + '/' + subDataType + '/list';
    }
    if (extraId) {
      urlStr = urlStr + '/' + extraId;
    }
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonGetRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          if (cached) {
            this.cachedObj[type + '/' + extraId] = jsonObj;
          }
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    });
  }
  public getUsersList(conf: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string) {
    let cleanConf = this.buildSearchRequestSToAPI(conf, '');
    let urlStr = this.authURL + 'user/search';
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    }, 'POST', cleanConf);
  }
  public getInvestigatorsList(caseId: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, cached: boolean = false, lang?: string) {
    let urlStr = this.authURL;
    urlStr = urlStr + 'case/investigators/' + caseId + '/list';
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonGetRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    });
  }
  public getCamerasList(caseId: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, cached: boolean = false, lang?: string) {
    let urlStr = this.authURL;
    urlStr = urlStr + 'case/camera/' + caseId + '/list';
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonGetRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    });
  }
  public getCamerasGroupList(caseId: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, cached: boolean = false, lang?: string) {
    let urlStr = this.authURL;
    urlStr = urlStr + 'case/cameragroup/' + caseId + '/list';
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonGetRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    });
  }
  public getInvestigatorGroupList(caseId: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, cached: boolean = false, lang?: string) {
    let urlStr = this.authURL;
    urlStr = urlStr + 'case/investigatorgroup/' + caseId + '/list';
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonGetRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    });
  }

  public assignInvestigators(cmId: any, data: any[], callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string) {
    let urlStr = this.authURL;
    urlStr = urlStr + 'case/investigators/' + cmId + '/assign';
    // urlStr = this.addLanguageToURL(urlStr, lang);

    let investigators = data.filter((itm) => !itm.isInvestigatorGroup);
    let investigatorGroups = data.filter((itm) => itm.isInvestigatorGroup);

    let fieldsToRemove = ['isInvestigatorGroup', 'selected'];
    // Function to remove fields from each object
    investigators = investigators.map(obj => {
      fieldsToRemove.forEach(field => {
        delete obj[field];
      });
      return obj;
    });
    investigatorGroups = investigatorGroups.map(obj => {
      fieldsToRemove.forEach(field => {
        delete obj[field];
      });
      return obj;
    });

    let objectpost = {
      investigators: investigators,
      investigatorgroup: investigatorGroups
    }
    this.jsonRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, 'Server Error!');
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    }, 'POST', objectpost);
  }
  public assignCameras(cmId: any, data: any[], callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string) {
    let urlStr = this.authURL;
    urlStr = urlStr + 'case/camera/' + cmId + '/assign';
    // urlStr = this.addLanguageToURL(urlStr, lang);
    let cameras = data.filter((itm) => !itm.isCameraGroup);
    let cameraGroups = data.filter((itm) => itm.isCameraGroup);

    let fieldsToRemove = ['isCameraGroup', 'selected'];
    // Function to remove fields from each object
    cameras = cameras.map(obj => {
      fieldsToRemove.forEach(field => {
        delete obj[field];
      });
      return obj;
    });
    cameraGroups = cameraGroups.map(obj => {
      fieldsToRemove.forEach(field => {
        delete obj[field];
      });
      return obj;
    });
    let objectpost = {
      cameras: cameras,
      cameragroups: cameraGroups
    }
    this.jsonRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, 'Server Error!');
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    }, 'POST', objectpost);
  }
  public assignCameraToCaseData(cameraId: string, caseId: string, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string) {
    let urlStr = this.authURL;
    urlStr = urlStr + 'case/assigncamera';
    let objectpost = {
      "case": {
        "_id": caseId
      },
      "camera": {
        "_id": cameraId
      }
    };
    this.jsonRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, 'Server Error!');
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    }, 'POST', objectpost);
  }
  public generatePlate(filename: any, data: any[], cameraId: string, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string) {
    let urlStr = this.authURL;
    urlStr = urlStr + 'carplate/sdk/create';
    // urlStr = this.addLanguageToURL(urlStr, lang);
    let objectpost = {
      datas: data,
      filename: filename,
      camera_id: cameraId,
    }
    this.jsonRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, 'Server Error!');
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    }, 'POST', objectpost);
  }
  public getMyUsersList(conf: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string) {
    let cleanConf = this.buildSearchRequestSToAPI(conf, '');
    let urlStr = this.authURL + 'my/user/search/summary';
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    }, 'POST', cleanConf);
  }
  public getUser(userId: string, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string) {
    let urlStr = this.authURL + 'user/' + userId;
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonGetRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    });
  }
  public registeruser(user: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string) {
    let urlStr = this.authURL + 'user/register';
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    }, 'POST', user);
  }
  public editUser(userId: any, user: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string) {
    let urlStr = this.authURL + 'user/' + userId;
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    }, 'POST', user);
  }
  public confirmUserPassword(email: string, confirmationCode: any, newpassword: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string) {
    let urlStr = this.authURL + 'user/confirm/forgotpassword';
    let encodedNewPassword = urlSafeBase64Encoding(newpassword);
    let user = { email: email.trim(), confirmationCode: confirmationCode, newPassword: encodedNewPassword };

    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    }, 'POST', user, ContentType.JSON, 10.0, false, 1.5, 60.0);
  }
  public editUserPassword(password: any, oldPassword: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string) {
    let urlStr = this.authURL + "user/" + this.currentUser._id + '/changepassword';

    let user = { newPassword: urlSafeBase64Encoding(password), currentPassword: urlSafeBase64Encoding(oldPassword) }
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    }, 'POST', user);
  }
  public editCurrentUserPassword(password: any, oldPassword: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string) {
    let urlStr = this.authURL + "user/changepassword";

    let user = { newpassword: urlSafeBase64Encoding(password), oldpassword: urlSafeBase64Encoding(oldPassword) }
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    }, 'POST', user);
  }
  public resetUserPassword(userId: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string) {
    let urlStr = this.authURL + 'resetpassword/' + userId;
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonGetRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    });
  }
  public requestPassword(useremail: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string) {
    let urlStr = this.authURL + 'requestpassword/' + useremail;
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    });
  }
  public editSelfUser(userId: any, user: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string) {
    let urlStr = this.authURL + 'userself/' + userId;
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    }, 'POST', user);
  }
  public saveDataToClass(classId: any, datatype: string, data: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string) {
    let urlStr = this.authURL + datatype + '/' + classId + '/save';
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    }, 'POST', data);
  }
  /**
   * Get Business Resource By Topic - DEMO MODE
   * Uses DemoDataService instead of HTTP call
   */
  public getBusinessResourceByTopic(topic: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string) {
    this.demoDataService.getResourcesByTopic(topic).then((response) => {
      const jsonObj = {
        status: true,
        results: response.results || response
      };
      callback(jsonObj, undefined);
    }).catch((error) => {
      if (error && error.hasOwnProperty('type')) {
        this.appStatusSubject.next(error.type);
      }
      callback(undefined, error?.message || error);
    });
  }
  public UpdateBusinessResourceByTopic(data: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string) {
    let urlStr = this.authURL + 'br/update';
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    }, 'POST', data);
  }

  public buildSearchRequestSToAPI(conf: any, token: string = '', addCustomData: boolean = true): {} {
    let searchRequestGeneric: any = {
      count: conf.perpage || 10
    };
    if (conf.perpage) {
      searchRequestGeneric['count'] = conf.perpage || 10;
    }
    if (searchRequestGeneric.count === -1) {
      delete searchRequestGeneric.count;
    }
    if (conf.orderBy && conf.orderDir) {
      searchRequestGeneric['order'] = [];
      searchRequestGeneric['order'].push({ field: conf.orderBy, order: conf.orderDir });
    }
    if (conf.order) {
      searchRequestGeneric['order'] = conf.order;
    }
    let fieldList: string[] = [];
    if (conf.hasOwnProperty('fieldKeys')) {
      fieldList = conf['fieldKeys'];
    }
    if (fieldList.length > 0) {
      searchRequestGeneric['fields'] = fieldList;
    }
    if (conf.hasOwnProperty('term') && conf['term'] !== undefined) {
      searchRequestGeneric['term'] = conf['term'] || '';
    }
    if (conf.hasOwnProperty('termfields') && conf['termfields'] !== undefined) {
      searchRequestGeneric['termfields'] = conf['termfields'] || '';
    }
    let filterList = {};
    if (conf.customData && addCustomData) {
      if (Object.keys(conf.customData).length > 0) {
        for (let field of Object.keys(conf.customData)) {
          if (field)
            filterList[field] = { op: 'eq', value: conf.customData[field] };
        }
      }
    }
    if (conf.filterFieldKey) {
      for (let field of conf.filterFieldKey) {
        if (field) {
          filterList[field.field] = { op: field.op, value: field.search };
          if (field.type && field.type === 'number') {
            filterList[field.field].value = Number(filterList[field.field].value);
          }
        }
      }
    }
    if (Object.keys(filterList).length > 0) {
      searchRequestGeneric['filter'] = filterList;
    }
    if (conf.hasOwnProperty('filter')) {
      searchRequestGeneric['filter'] = conf.filter;
    }
    if (conf.hasOwnProperty('page')) {
      searchRequestGeneric['page'] = conf.page;
    }
    if (token !== '') {
      searchRequestGeneric['paginationToken'] = token;
    }
    if (conf.hasOwnProperty('include') && conf['include'] !== undefined) {
      searchRequestGeneric['include'] = conf['include'] || [];
    }
    if (conf.hasOwnProperty('exclude') && conf['exclude'] !== undefined) {
      searchRequestGeneric['exclude'] = conf['exclude'] || [];
    }
    if (conf.hasOwnProperty('organizationId') && conf['organizationId'] !== undefined) {
      searchRequestGeneric['organizationId'] = conf['organizationId'] || '';
    }
    return searchRequestGeneric;
  }
  private getCorrectUrl(urlString) {
    let urlCorrectString = urlString;
    //check if it is a formLib module
    // for (let itm of this.formLibModules) {
    //   if (urlString.startsWith(this.authURL + itm)) {
    //     urlCorrectString = urlCorrectString.replace(this.authURL + itm, this.formLibrariesURL + itm);
    //   }
    // }
    // if (urlString.startsWith(this.authURL + 'event')) {
    //   urlCorrectString = urlCorrectString.replace(this.authURL + 'event', this.scheduleURL + 'event');
    //   return urlCorrectString || '';
    // }
    return urlCorrectString || '';
  }
  private urlEncode(str: string): string {
    return encodeURI(str);
  }
  private jsonRequestSimple(urlString: string, callback: (json?: any, error?: any) => void, params: Dictionary, timeout: number = 60.0) {
    let body;
    if (params) {
      body = params;
    } else {
      // we need to recheck this
      //console.log('Parameters sent to jsonRequestSimple are not serializable into JSON');
    }
    this.jsonRequest(urlString, (json, error) => {
      callback(json, error);
    }, 'POST', body, ContentType.JSON, timeout);
  }
  public jsonGetRequest(urlString: string, callback: (json?: any, error?: any) => void, params?: Dictionary) {
    if (urlString) {
      let urlComps = urlString;
      if (params) {
        for (let urlItem of Object.keys(params)) {
          urlComps += '&' + urlItem + '=' + params[urlItem];
        }
      }
      this.jsonRequest(urlComps, (json, error) => {
        callback(json, error);
      }, 'GET');
    } else {
      return;
    }
  }
  public jsonRequest(urlString: string,
    callback: (json: any, error: any) => void,
    method: string = 'POST',
    postBody: any = undefined,
    contentType: string = ContentType.JSON,
    timeout: number = 10.0,
    retry: boolean = false,
    retryFactor: number = 1.5,
    maxTimeout: number = 60.0,
    tempToken: string = undefined) {
    if (urlString) {
      let url: string = this.getCorrectUrl(urlString);
      let headers = {
        web: 'true',
        'Content-Type': contentType,
        // 'vertical': this.orgType,
        'Accept': 'application/json',
        'Access-Control-Allow-Origin': '*',
        // group: 'web',
      };

      // headers['lang'] = this.lang;
      // headers['project'] = environment.projectName;
      // headers['vertical'] = this.orgType;
      // headers['productid'] = environment.productId;
      // if (this.orgId && this.orgId !== '') {
      //   headers['organizationid'] = this.orgId;
      //   headers['integratedid'] = this.orgId;
      // }
      if (this.token) {
        headers['Authorization'] = this.token;
      }
      if (tempToken) {
        headers['Authorization'] = tempToken;
      }
      let httpOptions: any = {
        responseType: 'json',
        headers: new HttpHeaders(headers),
        method: method
      }

      let bodyString = postBody;
      if (method === 'POST') {

        bodyString = JSON.stringify(postBody);
        httpOptions['body'] = bodyString;
      }
      this.http.request(method, url, httpOptions)
        // .pipe(map(
        //     (res: any) => {
        //       // below might need to be changed
        //       if (res.status >= 404) {
        //         window.location.reload();
        //       } else if (res.status >= 400) {
        //         callback(undefined, 'server');
        //         return;
        //       }
        //       return res;
        //     }
        //   ))
        .subscribe(
          (data) => {
            if (data.hasOwnProperty('token')) {
              this.updateToken(data);
            }
            callback(data, undefined);
            // console.log(url, data);
          },
          (err) => {
            if (err) {
              if (err.status >= 404) {
                // window.location.reload();
                callback(undefined, this.translate.instant('Refresh page'));
              } else if (err.status >= 400) {
                if (this.currentUser) {
                  try {
                    let jsonErr = err.json();
                    if (jsonErr.hasOwnProperty('type') && jsonErr.type === 'login') {
                      this.appStatusSubject.next(jsonErr.type);
                    } else {
                      callback(undefined, this.translate.instant('Connectivity issue.'));
                    }
                  } catch (e1) {
                    try {
                      if (err.hasOwnProperty('error')) {
                        let jsonErr = err.error;
                        if (jsonErr.hasOwnProperty('type') && jsonErr.type === 'login') {
                          this.appStatusSubject.next(jsonErr.type);
                        } else {
                          callback(undefined, this.translate.instant('Connectivity issue.'));
                        }
                      } else {
                        callback(undefined, this.translate.instant('Connectivity issue.'));
                      }
                    } catch (e2) {
                      callback(undefined, this.translate.instant('Connectivity issue.'));
                    }
                  }
                } else {
                  callback(undefined, this.translate.instant('Connectivity issue.'));
                }
              } else {
                callback(undefined, err);
              }
            }
          });

    } else {
      // this.logger.log('Failed to create URL');
      //console.log('Failed to create URL');
    }
  }
  /**
   * Upload User Image - DEMO MODE
   * Returns fake success response instead of uploading
   */
  public onUploadUserImage(browsed_file: any, userId: string): Observable<{}> {
    console.log('[DEMO] onUploadUserImage - returning fake success');
    return this.demoDataService.uploadUserImage(userId, browsed_file).pipe(
      map((response: any) => {
        if (response && response.hasOwnProperty('token')) {
          this.updateToken(response);
        }
        return response;
      })
    );
  }
  /**
   * Upload Carplate Image - DEMO MODE
   * Returns fake success response instead of uploading
   */
  public onUploadCarplateImage(browsed_file: any): Observable<{}> {
    console.log('[DEMO] onUploadCarplateImage - returning fake success');
    return this.demoDataService.uploadCarplateFile(browsed_file).pipe(
      map((response: any) => {
        if (response && response.hasOwnProperty('token')) {
          this.updateToken(response);
        }
        return response;
      })
    );
  }

  public loadUserGroupsData(id: string, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string) {
    let urlStr = this.authURL + 'investigatorgroup/user/' + id + '/get';
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonGetRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    });
  }
  public selectImageGallery(type: string, id: string, imageId: string, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string) {
    let urlStr = this.authURL + type + '/copy/image/' + id + '/' + imageId;
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonGetRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    });
  }
  /**
   * Upload Files - DEMO MODE
   * Returns fake success response instead of uploading
   */
  public onUploadFiles(browsed_file: any, region: string = '', prefecture: string = '', type: string = '', isEncoded: string = 'false'): Observable<{}> {
    console.log('[DEMO] onUploadFiles - returning fake success');
    return of({
      status: true,
      results: {
        url: 'assets/images/demo-upload.jpg',
        message: 'File uploaded successfully (demo)'
      }
    }).pipe(delay(300), map((response: any) => {
      if (response.hasOwnProperty('token')) {
        this.updateToken(response);
      }
      return response;
    }));
  }
  /**
   * Upload Files By Path - DEMO MODE
   * Returns fake success response instead of uploading
   */
  public onUploadFilesByPath(path: string, browsed_file: any): Observable<{}> {
    console.log('[DEMO] onUploadFilesByPath - returning fake success');
    return of({
      status: true,
      results: {
        url: 'assets/images/demo-upload.jpg',
        message: 'File uploaded successfully (demo)'
      }
    }).pipe(delay(300), map((response: any) => {
      if (response.hasOwnProperty('token')) {
        this.updateToken(response);
      }
      return response;
    }));
  }
  /**
   * Upload Files By User - DEMO MODE
   * Returns fake success response instead of uploading
   */
  public onUploadFilesByUsr(userId: string, browsed_file: any, folder: string = '', type: string = '', isEncoded: string = 'false'): Observable<{}> {
    console.log('[DEMO] onUploadFilesByUsr - returning fake success');
    return of({
      status: true,
      results: {
        url: 'assets/images/demo-upload.jpg',
        message: 'File uploaded successfully (demo)'
      }
    }).pipe(delay(300), map((response: any) => {
      if (response.hasOwnProperty('token')) {
        this.updateToken(response);
      }
      return response;
    }));
  }
  public isUserAgent(userType?: any): boolean {
    if (this.currentUser) {
      if ([environment.customKeys.roleAgent].includes(this.currentUser['dup__of_type']))
        return true;
    }
    else if (userType) {
      if ([environment.customKeys.roleAgent].includes(userType))
        return true;
      return false;
    }
    else
      return false;
  }
  public isUserRoleAdmin(): boolean {
    if (this.currentUser) {
      if ([environment.customKeys.roleAdmin].includes(this.currentUser['dup__of_type']))
        return true;
    }
    return false;
  }
  public isUserRoleAgencyAdmin(userType?: any): boolean {
    if (this.currentUser) {
      if ([environment.customKeys.roleCoOwner, environment.customKeys.roleAgencyAdmin, environment.customKeys.roleOwner, environment.customKeys.rolePrincipleAgent].includes(this.currentUser['dup__of_type']))
        return true;
    }
    else if (userType) {
      if ([environment.customKeys.roleCoOwner, environment.customKeys.roleAgencyAdmin, environment.customKeys.roleOwner, environment.customKeys.rolePrincipleAgent].includes(userType))
        return true;
      return false;
    }
    else
      return false;
  }
  public isUserRoles(roles: any[]): boolean {
    let user = this.currentUser;
    if (user) {
      if (user['resources'].find(role => roles.includes(role['_id'])))
        return true;
    }
    return false;
  }
  public getUserRole(): string {
    let user = this.currentUser;
    if (user) {
      if ([environment.customKeys.roleCoOwner, environment.customKeys.roleAgencyAdmin, environment.customKeys.roleOwner, environment.customKeys.rolePrincipleAgent].includes(user['dup__of_type']))
        return environment.customKeys.roleAgencyAdmin;
      if ([environment.customKeys.roleAdmin].includes(user['dup__of_type']))
        return environment.customKeys.roleAdmin;
      if ([environment.customKeys.roleAgent].includes(user['dup__of_type']))
        return environment.customKeys.roleAgent;
    }
    return undefined;
  }
  // public getUserRole(): string {
  //   let user = this.currentUser;
  //   if (user) {
  //     if (user['resources'].find(role => role['_id'] == environment.customKeys.roleCaseManager))
  //       return 'edit';
  //     else if (user['resources'].find(role => role['_id'] == environment.customKeys.roleClient))
  //       return 'view';
  //     else if (user['resources'].find(role => role['_id'] == environment.customKeys.roleAdmin))
  //       return 'admin';
  //   }

  //   return 'anonymous';
  // }
  public getUserRoleByUserData(user): string {
    // if (user) {
    //   if (user['resources'].find(role => role['_id'] == environment.customKeys.roleEdit))
    //     return 'edit';
    //   else if (user['resources'].find(role => role['_id'] == environment.customKeys.roleView))
    //     return 'view';
    //   else if (user['resources'].find(role => role['_id'] == environment.customKeys.roleAdmin))
    return 'admin';
    // }
    // return 'anonymous';
  }
  public getUserClassRole(classData: any): string {
    return 'anonymous';
  }
  // public getUserRoomRole(roomData: any): string {
  //   if (roomData.hasOwnProperty('owner')) {
  //     for (let dt of roomData.owner) {
  //       if (this.currentUser && dt._id === this.currentUser._id) {
  //         return 'owner';
  //       }
  //     }
  //   }
  //   return this.getUserRole();
  // }
  // public getUserSessionRole(roomData: any): string {
  //   if (roomData.hasOwnProperty('users')) {
  //     for (let dt of roomData.users) {
  //       if (this.currentUser && dt._id === this.currentUser._id) {
  //         return dt.type;
  //       }
  //     }
  //   }
  //   if (this.getUserRole() === 'admin') {
  //     return 'admin';
  //   }
  //   return 'anonymous';
  // }

  // public getUserRoleByUserDataNoOrg(user): string {
  //   if (user) {
  //     if (user['resources'].find(role => role['_id'] == environment.customKeys.roleCaseManager))
  //       return 'edit';
  //     else if (user['resources'].find(role => role['_id'] == environment.customKeys.roleClient))
  //       return 'view';
  //     else if (user['resources'].find(role => role['_id'] == environment.customKeys.roleAdmin))
  //       return 'admin';
  //   }
  //   return 'anonymous';
  // }
  // public getSessionRoleByType(sessionData: any, type): any[] {
  //   let userList = [];
  //   if (sessionData.hasOwnProperty('users')) {
  //     for (let dt of sessionData.users) {
  //       if (dt.type === type) {
  //         userList.push(dt);
  //       }
  //     }
  //   }
  //   return userList;
  // }
  // public getSessionRoleByUser(sessionData: any, userId: string): string {
  //   if (sessionData.hasOwnProperty('users')) {
  //     for (let dt of sessionData.users) {
  //       if (dt._id === userId) {
  //         return dt.type;
  //       }
  //     }
  //   }
  //   return 'anonymous';
  // }
  /**
   * Post Request - DEMO MODE
   * Routes all POST requests to DemoDataService instead of making HTTP calls
   */
  postRequest(type: string, subType: string, data: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, tempToken: string = undefined) {
    // DEMO MODE: Route to DemoDataService based on type/subType
    this.handleDemoPostRequest(type, subType, data, callback, tempToken);
  }

  /**
   * Handle demo POST requests by routing to appropriate DemoDataService methods
   */
  private handleDemoPostRequest(type: string, subType: string, data: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, tempToken: string = undefined) {
    const endpoint = `${type}${subType ? '/' + subType : ''}`;
    
    console.log('[RequestService] handleDemoPostRequest called with:', { type, subType, endpoint, data });

    // Route to appropriate demo method based on endpoint
    let promise: Promise<any> | null = null;
    
    // Handle case where type contains the full endpoint path (e.g., "sendbird/user/register_operators_group_channel")
    if (type.includes('/') && !subType) {
      const parts = type.split('/');
      if (parts.length >= 2) {
        type = parts.slice(0, -1).join('/');
        subType = parts[parts.length - 1];
        console.log('[RequestService] Parsed endpoint:', { type, subType });
      }
    }

    // Auth endpoints
    if (type === 'user' && subType === 'auth/logout') {
      promise = this.demoDataService.logout(data.userId, data.deviceToken);
    }
    else if (type === 'user' && subType === 'auth/token') {
      promise = this.demoDataService.validateToken(data.accessToken || tempToken);
    }
    // PGI endpoints (already handled in PGIService, but keep for compatibility)
    else if (type === 'pgi' && !subType) {
      promise = this.demoDataService.getPGIOverview(data, data.agency);
    }
    else if (type === 'pgifilter' && !subType) {
      promise = this.demoDataService.getPGIOverviewFilter(data.agency_name, data.lob, data.state, data.productline, data.agent, data.carrier);
    }
    else if (type === 'opportunitiesFilters' && !subType) {
      promise = this.demoDataService.getTargetedFilter(data.agency_name, data.lob, data.state, data.productline, data.agent, data.carrier, data.dimension);
    }
    else if (type === 'profitabilityall' && !subType) {
      promise = this.demoDataService.getProfitabilityRetentionOverview(data);
    }
    else if (type === 'commissionsAll' && !subType) {
      promise = this.demoDataService.getCommissionOverview();
    }
    else if (type === 'opportunitiesAll' && !subType) {
      promise = this.demoDataService.getPGITargetedOpportunities();
    }
    else if (type === 'productionall' && !subType) {
      promise = this.demoDataService.getProductionData();
    }
    else if (type === 'profitabilityfilter' && !subType) {
      promise = this.demoDataService.getProfitabilityFilters(data.agency_name);
    }
    else if (type === 'pgi' && subType === 'userlist') {
      promise = this.demoDataService.getUsers(data.agency_name, data.productline, data.carrier, data.state, data.lob, data.agency);
    }
    else if (type === 'usersNotify' && !subType) {
      promise = this.demoDataService.getUsersByFilters(data.role, data.states, data.access_type, data.carriers);
    }
    else if (type === 'orchestrators' && subType === 'downloadWinback') {
      promise = this.demoDataService.getWinbackDownloadList(data.month);
    }
    else if (type === 'mondayContactsList' && !subType) {
      promise = this.demoDataService.getAllContactList(data.user_type, data.email);
    }
    // Channel endpoints
    else if (type === 'channel' && subType === 'get') {
      promise = this.demoDataService.getChannelPreferences(data.userId);
    }
    else if (type === 'channel' && subType === 'add') {
      promise = this.demoDataService.addChannelPreferences(data.userId, data.channelId, data.dnd);
    }
    else if (type === 'channel' && subType === 'pinned/get') {
      promise = this.demoDataService.getPinnedMessage(data.channelId);
    }
    else if (type === 'channel' && subType === 'pinned/add') {
      promise = this.demoDataService.addPinnedMessage(data.channelId, data.messageId);
    }
    else if (type === 'channel' && subType === 'pinned/delete') {
      promise = this.demoDataService.deletePinnedMessage(data.channelId, data.messageId);
    }
    // Sendbird endpoints
    else if (type === 'sendbird/user' && subType === 'createGroupChannel') {
      promise = this.demoDataService.createGroupChannel(data.user_ids, data.name, data.operator_ids);
    }
    else if (type === 'sendbird/user' && subType === 'listgroupchannel') {
      promise = this.demoDataService.listGroupChannels(data.userId, data.limit, data.token);
    }
    else if (type === 'sendbird' && subType === 'user/listmessages') {
      promise = this.demoDataService.listMessages(data.channel_url, data.message_ts, data.next_limit);
    }
    else if (type === 'sendbird' && subType === 'user/sendmessage') {
      promise = this.demoDataService.sendMessage(data.channel_url, data.message, data.message_type, data.user_id);
    }
    else if (type === 'sendbird' && subType === 'user/create') {
      promise = this.demoDataService.createSendbirdUser(data.userId, data.profile, data.name);
    }
    else if (type === 'sendbird' && subType === 'user/update/message') {
      promise = this.demoDataService.updateMessage(JSON.parse(data.data), data.url, data.custom_type);
    }
    else if (type === 'sendbird' && subType === 'update/messagemetadata') {
      promise = this.demoDataService.updateMessageMetadata(data.channel_url, data.message_id, data);
    }
    // Handle sendbird/user/register_operators_group_channel (can be passed as full endpoint or split)
    else if ((type === 'sendbird/user' && subType === 'register_operators_group_channel') || 
             (type === 'sendbird/user/register_operators_group_channel' && !subType)) {
      promise = this.demoDataService.registerOperatorsGroupChannel(data.operator_ids, data.channel_url);
    }
    // Handle sendbird/user/unregister_group_channel (can be passed as full endpoint or split)
    else if ((type === 'sendbird/user' && subType === 'unregister_group_channel') ||
             (type === 'sendbird/user/unregister_group_channel' && !subType)) {
      promise = this.demoDataService.unregisterGroupChannel(data.operator_ids, data.channel_url, data.delete_all);
    }
    else if (type === 'sendbird' && subType === 'operatorsgroupchannel/list') {
      promise = this.demoDataService.listOperatorsGroupChannel(data.limit, data.channel_url);
    }
    else if (type === 'sendbird' && subType === 'invite/member') {
      promise = this.demoDataService.inviteMember(data.user_ids, data.channel_url, data.inviter_id);
    }
    else if (type === 'sendbird' && subType === 'leave/channel') {
      promise = this.demoDataService.leaveChannel(data.user_ids, data.channel_url, data.reason);
    }
    else if (type === 'sendbird' && subType === 'registeruserdevice') {
      promise = this.demoDataService.registerUserDevice(data.user_id, data.token_type, data.gcm_reg_token);
    }
    else if (type === 'sendbird' && subType === 'unregisteruserdevice') {
      promise = this.demoDataService.unregisterUserDevice(data.user_id, data.token_type, data.token);
    }
    // Notification/Alert endpoints
    else if (type === 'notify' && subType === 'alert/search') {
      promise = this.demoDataService.getAlertsDemo(data.page, data.count, data.role);
    }
    else if (type === 'sendbird' && subType === 'user/updateGroupChannel') {
      promise = this.demoDataService.updateGroupChannel(data.name, data.custom_type, data.channel_url);
    }
    else if (type === 'sendbird' && subType === 'members/groups/list') {
      promise = this.demoDataService.listMembersGroups(data.limit, data.channel_url);
    }
    else if (type === 'sendbird' && subType === 'group/channel/delete') {
      promise = this.demoDataService.deleteGroupChannel(data.channel_url);
    }
    else if (type === 'sendbird' && subType === 'user/getmessage') {
      promise = this.demoDataService.getMessage(data.channel_url, data.message_id);
    }
    // Notification endpoints
    else if (type === 'notify' && subType === 'topic/v1') {
      promise = this.demoDataService.sendNotificationByTopic(
        data.topic, data.userId, data.payload, data.title, data.body,
        data.priority, data.pushedBy, data.recipients, data.role,
        data.state, data.carrier, data.agency_name
      );
    }
    else if (type === 'notify' && subType === 'history') {
      promise = this.demoDataService.getNotificationHistory(data.userId, data.page || 0, data.count || 10);
    }
    else if (type === 'notify' && subType === 'users/send') {
      // Save alert to localStorage in demo mode
      const currentUser = this.currentUser;
      promise = this.demoDataService.saveAlert({
        ...data,
        userId: currentUser?._id || currentUser?.text7__1 || 'demo_user',
        pushedBy: {
          _id: currentUser?._id || currentUser?.text7__1 || 'demo_user',
          name: currentUser?.name || 'Current User',
          email: currentUser?.email || 'user@example.com'
        }
      });
    }
    else if (type === 'notify' && (subType === 'topic/send' || subType.startsWith('firebase/'))) {
      // Generic notification endpoints - return success
      promise = Promise.resolve({
        status: true,
        message: 'Notification sent successfully (demo)'
      });
    }
    // File endpoints
    else if (type === 'file' && subType === 'inline-token') {
      promise = this.demoDataService.getFileInlineToken(data.fileurl || data.url || '', data.fileId);
    }
    // Default: return success for unknown endpoints (demo mode)
    else {
      console.log(`[DEMO] postRequest: ${endpoint} - returning success`);
      promise = Promise.resolve({
        status: true,
        results: data,
        message: `Demo response for ${endpoint}`
      });
    }

    // Execute promise and call callback
    if (promise) {
      promise
        .then((response) => {
          // Special handling for mondayContactsList - return data directly without status wrapper
          if (type === 'mondayContactsList' && response && (response.hasOwnProperty('agents') || response.hasOwnProperty('admins') || response.hasOwnProperty('agencies'))) {
            // Return the response directly without wrapping
            callback(response, undefined);
            return;
          }

          // Format response to match expected structure
          let jsonObj: any;
          if (response && response.status !== undefined) {
            jsonObj = response;
          } else {
            jsonObj = {
              status: true,
              results: response
            };
          }

          // Handle special cases
          if (jsonObj.hasOwnProperty('type') && jsonObj.type === 'login') {
            this.appStatusSubject.next(jsonObj.type);
            this.logout(false, false);
          } else if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }

          if (jsonObj.status) {
            callback(jsonObj, undefined);
          } else {
            callback(undefined, jsonObj.message || 'Error');
          }
        })
        .catch((error) => {
          callback(undefined, error?.message || 'Server Error!');
        });
    } else {
      callback(undefined, 'Endpoint not implemented in demo mode');
    }
  }

  /**
   * Get Request - DEMO MODE
   * Routes all GET requests to DemoDataService instead of making HTTP calls
   */
  getRequest(type: string, subType: string, callback: (dataResponse: any | undefined, requestError: any | undefined) => void) {
    // DEMO MODE: Return success for GET requests
    const endpoint = `${type}/${subType}`;
    console.log(`[DEMO] getRequest: ${endpoint} - returning success`);
    
    Promise.resolve({
      status: true,
      results: {},
      message: `Demo response for ${endpoint}`
    }).then((jsonObj: any) => {
      if (jsonObj.status) {
        callback(jsonObj, undefined);
      } else {
        if (jsonObj.hasOwnProperty('type') && jsonObj.type === 'login') {
          this.appStatusSubject.next(jsonObj.type);
          this.logout(false, false);
        } else if (jsonObj.hasOwnProperty('type')) {
          this.appStatusSubject.next(jsonObj.type);
        }
        callback(undefined, jsonObj.message);
      }
    }).catch((error: any) => {
      callback(undefined, error?.message || 'Server Error!');
    });
  }

  getSessionHost(sessionData: any): string {
    if (sessionData.hasOwnProperty('users')) {
      for (let dt of sessionData.users) {
        if (dt.host) {
          return dt._id;
        }
      }
    }
    return undefined;
  }
  public isUserRoleSuperAdmin(): boolean {
    // let user = this.currentUser;
    // if (user && user.isSuperAdmin) {
    //   if (user['resources'].find(role => role['_id'] === environment.customKeys.roleAdmin && role['organizationId'] === this.orgId))
    // return true;
    // }
    return false;
  }
  public onUploadFilesByPathNew(
    path: string,
    browsed_file: any,
    type: string = undefined,
    isEncoded: string = undefined,
    id: string = undefined,
    folder: string = undefined,
    addName: boolean = true
  ): Observable<HttpEvent<any>> {
    let headers = {
      web: 'true',
      Authorization: this.token,
      Accept: 'application/json',
      group: 'web',
    };
    headers['lang'] = this.lang;
    headers['project'] = environment.projectName;
    // headers['vertical'] = this.orgType;
    headers['productid'] = environment.productId;
    if (this.orgId && this.orgId !== '') {
      headers['organizationid'] = this.orgId;
      headers['integratedid'] = this.orgId;
    }
    let httpOptions: any = {
      headers: new HttpHeaders(headers),
      reportProgress: true,
      responseType: 'json',
    };
    let url = this.authURL + path;
    const formData: FormData = new FormData();
    formData.append('upfile', browsed_file.originalFile);
    if (addName) {
      formData.append('name', browsed_file.text);
    }
    if (folder !== undefined) {
      formData.append('folder', folder);
    }
    if (type !== undefined) {
      formData.append('type', type);
    }
    if (id !== undefined) {
      formData.append('id', id);
    }
    if (isEncoded !== undefined) {
      formData.append('isEncoded', isEncoded);
    }

    const req = new HttpRequest('POST', url, formData, httpOptions);
    return this.http.request(req);
  }
  public updateToken(jsonObj: any) {
    let userObject = this.currentUser;
    if (jsonObj.hasOwnProperty('token')) {
      if (jsonObj.token) {
        this.setToken(jsonObj.token);
        this.store.set('token', jsonObj.token);
      }
      if (userObject) {
        userObject['token'] = jsonObj.token;
        localStorage.setItem('currentUser', JSON.stringify(userObject));
        this.currentUserSubject.next(userObject);
      }
    }
  }

  public getUserInfoByEmail(email: string, callback: (dataResponse: any | undefined, requestError: any | undefined) => void, lang?: string) {
    let urlStr = this.authURL + 'user/validate/superadmin?email=' + encodeURIComponent(email.trim());
    urlStr = this.addLanguageToURL(urlStr, lang);
    this.jsonGetRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj.results, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    });
  }
  /**
   * Get Image Base64 - DEMO MODE
   * Returns demo image data instead of downloading
   */
  public getImageBase64(url: string, callback: (base64: string | null) => void): void {
    console.log('[DEMO] getImageBase64 - returning demo image');
    // Return a demo base64 image (1x1 transparent PNG)
    const demoBase64 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+M9QDwADhgGAWjR9awAAAABJRU5ErkJggg==';
    callback(demoBase64);
  }

  public getAISummary(
    channelId: string,
    summaryType: string,
    userId: string,
    callback: (
      dataResponse: any | undefined,
      requestError: any | undefined
    ) => void
  ) {

    // Get current timezone name using built-in method
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Denver';

    let urlStr = this.authURL + 'ai/get-summary' + '?channel_url=' + channelId + '&summary_type=' + summaryType + '&user_id=' + userId + '&timezone=' + timezone;

    this.jsonGetRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    });
  }
  public getRecord(
    id: string,
    type: string,
    callback: (
      dataResponse: any | undefined,
      requestError: any | undefined
    ) => void
  ) {
    let urlStr = this.authURL + type;
    if (id !== '') {
      urlStr = urlStr + '/' + id;
    }
    this.jsonGetRequest(urlStr, (jsonObj, error) => {
      if (error !== undefined) {
        callback(undefined, error);
        return;
      }
      if (jsonObj) {
        if (jsonObj.status) {
          callback(jsonObj, undefined);
        } else {
          if (jsonObj.hasOwnProperty('type')) {
            this.appStatusSubject.next(jsonObj.type);
          }
          callback(undefined, jsonObj.message);
        }
      } else {
        callback(undefined, error);
      }
    });
  }

  /**
   * Upload File - DEMO MODE
   * Returns fake success response with progress simulation
   */
  public onUploadFile(browsed_file: any, title: string): Observable<any> {
    console.log('[DEMO] onUploadFile - storing file for demo');
    
    const file = browsed_file?.originalFile || browsed_file;
    if (!file || !(file instanceof File)) {
      return throwError(() => ({ status: false, message: 'Invalid file provided.' }));
    }

    // Simulate upload progress
    return of({ progress: 0 }).pipe(
      delay(100),
      map(() => {
        this.fileUploadProgress.next(25);
        return { progress: 25 };
      }),
      delay(200),
      map(() => {
        this.fileUploadProgress.next(50);
        return { progress: 50 };
      }),
      delay(200),
      map(() => {
        this.fileUploadProgress.next(75);
        return { progress: 75 };
      }),
      delay(200),
      switchMap(() => {
        // Store file using DemoDataService
        return new Observable(observer => {
          this.demoDataService.storeFile(file).then(fileInfo => {
            this.fileUploadProgress.next(100);
            setTimeout(() => {
              this.fileUploadProgress.next(0);
              observer.next({
                status: true,
                results: fileInfo.url,
                fileId: fileInfo.fileId,
                message: 'File uploaded successfully (demo)'
              });
              observer.complete();
            }, 100);
          }).catch(error => {
            this.fileUploadProgress.next(0);
            observer.error({ status: false, message: 'Error storing file: ' + error });
          });
        });
      }),
      takeUntil(this.$destroy),
      catchError((error) => {
        this.fileUploadProgress.next(0);
        return throwError(() => ({ status: false, message: 'An error occurred during upload.' }));
      })
    );
  }

  public sendAnroidFirebaseNotification(data: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void) {
    if (data.deviceToken && data.deviceToken.length > 0) {
      let urlStr = this.authURL + 'notification/firebase/android';

      if (!data['webPush']) {
        data["webPush"] = {
          "notification": {
            "icon": "/assets/images/notification-logo.png"
          },
          "headers": {
            "TTL": "300"
          }
        };
      }
      if (!data["fcmOptions"]) {
        data["fcmOptions"] = {
          "link": environment.serverMainUrl
        };
      }

      this.jsonRequest(urlStr, (jsonObj, error) => {
        if (error !== undefined) {
          callback(undefined, error);
          return;
        }
        if (jsonObj) {
          if (jsonObj.status) {
            callback(jsonObj, undefined);
          } else {
            if (jsonObj.hasOwnProperty('type')) {
              this.appStatusSubject.next(jsonObj.type);
            }
            callback(undefined, jsonObj.message);
          }
        } else {
          callback(undefined, error);
        }
      }, 'POST', data);
    }
  }

  public sendWebFirebaseNotification(data: any, callback: (dataResponse: any | undefined, requestError: any | undefined) => void) {
    if (data.deviceToken && data.deviceToken.length > 0) {
      let urlStr = this.authURL + 'notification/firebase';

      if (!data['webPush']) {
        data["webPush"] = {
          "notification": {
            "icon": "/assets/images/notification-logo.png"
          },
          "headers": {
            "TTL": "300"
          }
        };
      }
      if (!data["fcmOptions"]) {
        data["fcmOptions"] = {
          "link": environment.serverMainUrl
        };
      }

      this.jsonRequest(urlStr, (jsonObj, error) => {
        if (error !== undefined) {
          callback(undefined, error);
          return;
        }
        if (jsonObj) {
          if (jsonObj.status) {
            callback(jsonObj, undefined);
          } else {
            if (jsonObj.hasOwnProperty('type')) {
              this.appStatusSubject.next(jsonObj.type);
            }
            callback(undefined, jsonObj.message);
          }
        } else {
          callback(undefined, error);
        }
      }, 'POST', data);
    }
  }

  dataURLToBlob(dataURL: string): Blob {
    const byteString = atob(dataURL.split(',')[1]);
    const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);

    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ab], { type: mimeString });
  }

  dataImageToFile(dataURL: string, filename: string): File {
    const blob = this.dataURLToBlob(dataURL);
    return new File([blob], filename, { type: blob.type });
  }

  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  /**
   * Send verification code - DEMO MODE
   * Uses DemoDataService instead of HTTP call
   */
  sendCode(email, password, verificationType?: 'email' | 'sms', phoneNumber?: string, handshakeToken?: string): Promise<any> {
    return this.demoDataService.sendCode(email, password, verificationType, phoneNumber, handshakeToken);
  }

  /**
   * Send SMS code - DEMO MODE
   * Uses DemoDataService instead of HTTP call
   */
  sendSmsCode(handshakeToken: string, phoneNumber?: string): Promise<any> {
    console.log('[DEMO] sendSmsCode called with token', phoneNumber ? 'and phone' : '');
    return this.demoDataService.sendSmsCode(handshakeToken, phoneNumber);
  }

  /**
   * Verify SMS code - DEMO MODE
   * Uses DemoDataService instead of HTTP call
   */
  verifySmsCode(handshakeToken: string, code: string, updatePhoneInDatabase?: boolean): Promise<any> {
    console.log('[DEMO] verifySmsCode called with token');
    return this.demoDataService.verifySmsCode(handshakeToken, code, updatePhoneInDatabase);
  }
}
